interface Blob {
    readonly size: number;
    readonly type: string;
    slice(start?: number, end?: number, contentType?: string): Blob;
}

type BufferSource = ArrayBufferView | ArrayBuffer;

type BlobPart = BufferSource | Blob | string;

type EndingType = 'transparent' | 'native';
interface BlobPropertyBag {
    endings?: EndingType;
    type?: string;
}

declare const Blob: {
    prototype: Blob;
    new (blobParts?: BlobPart[], options?: BlobPropertyBag): Blob;
};

export default (blob: Blob) => {
    const newBlob = new Blob([blob], { type: 'application/vnd.google-earth.kml+xml' });
    const reportName =
        'report_' +
        new Date()
            .toLocaleString()
            .replaceAll(/[^\dA-Za-z]/g, '-')
            .replaceAll('--', '_');

    const link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.download = `${reportName}.kml`;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    link.href = URL.createObjectURL(newBlob as any);

    link.click();

    URL.revokeObjectURL(link.href);
};
